import { render, staticRenderFns } from "./shippingRuleForm.vue?vue&type=template&id=1f0fc3de"
import script from "./shippingRuleForm.vue?vue&type=script&lang=js"
export * from "./shippingRuleForm.vue?vue&type=script&lang=js"
import style0 from "./shippingRuleForm.vue?vue&type=style&index=0&id=1f0fc3de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports